import TagManager from '@sooro-io/react-gtm-module';
import { useEffect, useMemo } from 'react';
import { useLocation, useMatches } from 'react-router-dom';

import { getAwsRum } from '../utils/rum';

export const useRecordPageView = () => {
  const location = useLocation();
  useEffect(() => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'page_view'
      }
    });
  }, [location.pathname]);

  const matches = useMatches();

  const currentRouteId = useMemo(() => {
    return matches[matches.length - 1]?.id;
  }, [matches]);

  useEffect(() => {
    if (currentRouteId) {
      const rum = getAwsRum();
      rum?.recordPageView({ pageId: currentRouteId });
    }
  }, [currentRouteId]);
};
